import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useSitStores} from "../../../../stores";
import {AuditLogTable} from "../../../components/AuditLogTable";

export const TargetAuditLogForm: React.FC = observer(() => {
    const {targetInstanceStore, auditLogStore} = useSitStores();
    const result = auditLogStore.targetAuditLogRM.result;

    useEffect(() => {
        if (targetInstanceStore.instance.id) {
            auditLogStore.targetAuditLogRM.request({id: targetInstanceStore.instance.id});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetInstanceStore.instance.id]);

    return <AuditLogTable entries={result}/>;
});
